<header class="p-10 bg-primary text-white w-full text-left">
	<h1 class="text-3xl font-semibold">
		{{ context.data.headerText }}
	</h1>

	@if (context.data.subheaderText) {
		<p class="text-lg font-normal">
			{{ context.data.subheaderText }}
		</p>
	}
</header>
